export const EMU_OPTIMIZED_LAYER_NAME = 'EMU 2018 Optimized';
